export const Attivita_section2 = () => {
    return (
        <div>
            <h3> <img src={"images/centroestivo/loghi/logo_pierschool.png"} width="15%"/> </h3><h3 className="shadowtext-1bl">Windsurf, Surf, Sup</h3>
            <h6 className="new-badge align-center">NEW</h6>
            <br />
            <h3> <img src={"images/centroestivo/loghi/logo_cambusiero.png"} width="25%"/> </h3><h3 className="shadowtext-1bl">Mare, <br/> giochi in spiaggia</h3>
            <br />
            <h3> <img src={"images/centroestivo/loghi/logo_ortostorto.png"} width="25%"/> </h3><h3 className="shadowtext-1bl">Bee-Happy</h3>
            <h6 className="new-badge align-center">NEW</h6>
           
        </div>
    )
}